import { Link } from 'react-router-dom'

const SECTIONS = [
  {
    h: 'Welcome to True North Care & Support',
    paras: [
      'These Terms of Use govern your access to and use of the True North Care & Support website. By using this website, you agree to these terms. If you do not agree, please do not use the website.',
    ],
  },
  {
    h: 'Non-medical care services',
    paras: [
      'True North Care & Support provides non-medical in-home care and support services. Our services may include companionship, personal support, meal preparation, housekeeping assistance, respite care, and related non-medical services.',
      'Nothing on this website is intended to provide medical advice, diagnosis, treatment, nursing care, or emergency care. Medical concerns should be directed to a qualified healthcare professional. In an emergency, call 911 or your local emergency service.',
    ],
  },
  {
    h: 'Website information',
    paras: [
      'The information on this website is provided for general informational purposes only. While we aim to keep the content accurate and current, service details, availability, care options, scheduling, rates, and policies may change.',
      'Information on this website does not create a client relationship, care agreement, employment relationship, or guarantee of service. Services are confirmed only after an assessment, care planning process, and acceptance by True North Care & Support.',
    ],
  },
  {
    h: 'Assessments and service availability',
    paras: [
      'Submitting a contact form, requesting an assessment, or contacting us through the website does not guarantee that services will be provided. Service availability depends on location, care needs, caregiver availability, scheduling, and whether we are able to safely and appropriately support the requested care.',
    ],
  },
  {
    h: 'Pricing, billing, and cancellations',
    paras: [
      'Any pricing, rate, or service information shown on this website is general in nature unless clearly stated otherwise. Final rates, minimum shift requirements, billing terms, cancellation policies, and service conditions are confirmed directly with clients or families before care begins and may be included in a written care agreement.',
    ],
  },
  {
    h: 'User responsibilities',
    paras: [
      'You agree to use this website only for lawful purposes. You must not misuse the website, attempt to interfere with its operation, submit false or misleading information, or use the website in a way that could harm True North Care & Support, other users, or the security of the website.',
    ],
  },
  {
    h: 'Third-party links',
    paras: [
      'This website may include links to third-party websites or resources. These links are provided for convenience only. True North Care & Support is not responsible for the content, privacy practices, accuracy, or availability of third-party websites.',
    ],
  },
  {
    h: 'Intellectual property',
    paras: [
      'All content on this website, including text, images, graphics, logos, page layouts, and design elements, is owned by or licensed to True North Care & Support unless otherwise stated. You may view and print website content for personal, non-commercial use only. You may not copy, reproduce, modify, distribute, or use website content for commercial purposes without written permission.',
    ],
  },
  {
    h: 'Limitation of liability',
    paras: [
      'To the fullest extent permitted by law, True North Care & Support is not responsible for any loss, damage, or expense arising from your use of this website, reliance on website content, temporary website unavailability, or links to third-party websites.',
    ],
  },
  {
    h: 'Changes to these terms',
    paras: [
      'True North Care & Support may update these Terms of Use from time to time. The updated version will be posted on this page with a revised "Last updated" date. Continued use of the website after changes are posted means you accept the updated terms.',
    ],
  },
]

const headingStyle = {
  margin: '0 0 12px 0',
  fontSize: 'clamp(1.35rem, 4.5vw, 1.75rem)',
  lineHeight: 1.2,
  color: 'var(--color-teal-900)',
}
const paraStyle = { margin: '0 0 16px 0', fontSize: 17, lineHeight: 1.7, color: 'var(--color-muted)' }
const linkStyle = { color: 'var(--color-teal-800)', fontWeight: 600, textDecoration: 'underline', textUnderlineOffset: 4 }

export default function Terms() {
  return (
    <section className="section">
      <div className="container-site">
        <div style={{ maxWidth: 820 }}>
          <p className="eyebrow">Terms of Use</p>
          <h1
            style={{
              margin: '12px 0 0 0',
              fontSize: 'clamp(2rem, 6vw, 2.9rem)',
              lineHeight: 1.15,
              color: 'var(--color-teal-900)',
            }}
          >
            Using the True North Care &amp; Support website
          </h1>
          <p style={{ margin: '12px 0 32px 0', fontSize: 15, color: 'var(--color-muted)' }}>Last updated: July 2026</p>

          {SECTIONS.map((s) => (
            <div key={s.h} style={{ marginBottom: 40, borderTop: '1px solid var(--color-line)', paddingTop: 32 }}>
              <h2 style={headingStyle}>{s.h}</h2>
              {s.paras.map((p) => (
                <p key={p} style={paraStyle}>
                  {p}
                </p>
              ))}
            </div>
          ))}

          {/* Privacy — links to the policy it references */}
          <div style={{ marginBottom: 40, borderTop: '1px solid var(--color-line)', paddingTop: 32 }}>
            <h2 style={headingStyle}>Privacy</h2>
            <p style={paraStyle}>
              Your use of this website is also subject to our{' '}
              <Link to="/privacy" style={linkStyle}>
                Privacy Policy
              </Link>
              . Please review it to understand how we collect, use, and protect personal information submitted through
              the website.
            </p>
          </div>

          <div style={{ borderTop: '1px solid var(--color-line)', paddingTop: 32 }}>
            <h2 style={headingStyle}>Contact us</h2>
            <p style={{ ...paraStyle, marginBottom: 0 }}>
              If you have questions about these Terms of Use, please{' '}
              <Link to="/contact" style={linkStyle}>
                contact True North Care &amp; Support
              </Link>
              .
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
